import { createActionGroup, props } from '@ngrx/store';

import { DiagStackGenericResponse } from '@vi-iot/client';

export namespace DiagStackDtcActions {
  export const getActiveDtc = createActionGroup({
    source: 'Diag stack dtc Get active DTC attempt',
    events: {
      attempt: props<{ gatewaySerial: string }>(),
      success: props<{
        gatewaySerial: string;
        activeDtcResponse: DiagStackGenericResponse;
      }>(),
      error: props<{
        gatewaySerial: string;
        activeDtcError: any;
      }>(),
    },
  });
}
